// Pure cart-session decisions shared by logout and the cart module (epoch guard, auth-denied test).
// No Vue, axios, or Mango imports — node tests load this file directly.

let cartEpoch = 0

export function currentCartEpoch() {
	return cartEpoch
}

/** Drop in-flight saves from the cart module that was bound before logout. */
export function bumpCartEpoch() {
	cartEpoch += 1
	return cartEpoch
}

export function isStaleCartEpoch(epoch) {
	return epoch !== cartEpoch
}

export function emptyGuestCart() {
	return {
		cartItems: [],
		certificates: [],
		coupon: { code: '' },
		couponDiscount: 0,
		couponType: false,
		certificate: null,
		certificateDiscount: 0,
	}
}

export function isAuthDeniedError(error) {
	const status = Number(error?.response?.status ?? error?.status)
	if (status === 401 || status === 403) return true
	const data = error?.response?.data ?? error?.data ?? error
	if (data?.authorized === false) return true
	if (data?.response?.authorized === false) return true
	return false
}

/**
 * A shopper with no stored user and no stored token is a guest, even when an
 * initCart closure still holds the member object from before logout.
 */
export function isGuestShopper(user, storage) {
	let userId = ''
	let token = ''
	try {
		const store = storage || (typeof window !== 'undefined' ? window.localStorage : null)
		userId = store?.getItem?.('user') || ''
		token = store?.getItem?.('token') || ''
	} catch {
		userId = ''
		token = ''
	}
	if (userId || token) return false
	return true
}
